import React from 'react';
import styled from 'styled-components';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';

import Media from 'css/Media';

export const FactBox = props => {

    const { data, last } = props;

    return (
        <ModuleWrapper last={last}>
            <Container grid mobileBleed>
                <StyledGridElement
                    colStart={{default: 1, s: 7}}
                    colEnd={{default: 8, s: 18}}
                >
                    <InnerContainer>
                        <GridElement
                            colStart={{default: 2, s: 2}}
                            colEnd={{default: 7, s: 10}}
                            rowStart={1}
                        >
                            <h3>{data.title}</h3>
                        </GridElement>
                        <GridElement
                            colStart={{default: 2, s: 2}}
                            colEnd={{default: 7, s: 10}}
                            rowStart={2}
                        >
                            <Html content>
                                {data.content}
                            </Html>
                        </GridElement>
                    </InnerContainer>
                </StyledGridElement>
            </Container>
        </ModuleWrapper>
    )
}

export default FactBox;

const ModuleWrapper = styled.section`
    margin: ${props => props.last ? `${props.theme.spacing.elementM} 0 0`: `${props.theme.spacing.elementM} 0`};

    ${Media.greaterThan('s')`
        margin: ${props => props.last ? `${props.theme.spacing.blockM} 0 0` : `${props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockL}`};
    `}
`

const StyledGridElement = styled(GridElement)`
    background: ${props => props.theme.colors.bg};
    padding: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        padding: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementXL};
    `}
`

const InnerContainer = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 25px (1fr .33fr)[3] 1fr 25px;
    grid-template-columns: 25px repeat(3, 1fr .33fr) 1fr 25px;
    
    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
    `}

    h3 {
        ${props => props.theme.fonts.p}
        font-size: 14px;
        font-weight: 600;
        margin-bottom: ${props => props.theme.spacing.contentL};
        
        ${Media.greaterThan('s')`
            font-size: 18px;
            margin-bottom: ${props => props.theme.spacing.elementXS};
        `}
    }

    p, ul li {
        font-size: 14px;
        
        ${Media.greaterThan('s')`
            font-size: 18px;
        `}
    }

    ul li {
        margin-bottom: ${props => props.theme.spacing.contentS};

        &:last-of-type {
            margin-bottom: 0;
        }

        ${Media.greaterThan('s')`
            margin-bottom: ${props => props.theme.spacing.contentM};
        `}
    }
`